import * as actionTypes from '../actionTypes'
import { updateObject } from '../shared/utility'

export const initialState = {
  users: {}
}

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const accessedUsersReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.RESET_STATE:
      return initialState

    case actionTypes.GETTING_ACCESSED_USERS_SUCCESS:
      return updateObject(state, {
        loading: false,
        accessUserList: action?.data?.users,
        pagination: {
          page: action?.data?.page,
          limit: action?.data?.limit,
          total_records: action?.data?.total_records
        }
      })
    case actionTypes.GETTING_ACCESSED_USERS_FAILURE:
      return updateObject(state, {
        loading: false,
        users: {}
      })
    default:
      return state
  }
}

export default accessedUsersReducer
